import React, { useState, useRef } from 'react';
import Slider from 'react-slick';
import Icon from '@common/assets';
import Image from '@components/common/image';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';
import classnames from 'classnames/bind';
import styles from './companyImage.module.scss';
const cx = classnames.bind(styles);

interface CompanyImageProps {
  positionDetail: PositionDetailVO;
}

const CompanyImage = ({ positionDetail }: CompanyImageProps) => {
  const [activeSlideIndex, setActiveSlideIndex] = useState(1);

  const settings = {
    speed: 300,
    fade: true,
    draggable: false,
    afterChange: (currentIndex: number) => setActiveSlideIndex(currentIndex + 1),
  };
  const sliderRef = useRef<Slider>(null);

  if (!positionDetail?.basicInfo) return null;

  const { images } = positionDetail.basicInfo;

  if (!images?.length) return null;

  const handlePrev = () => {
    sliderRef.current?.slickPrev();
  };

  const handleNext = () => {
    sliderRef.current?.slickNext();
  };

  const imaListEls = images.map((positionAttachFile, i) => {
    const { fileUrl, caption, description } = positionAttachFile;

    return (
      <div key={i} className={cx('listItem')}>
        <div className={cx('imgWrap')}>
          <Image src={fileUrl} width={424} height={320} alt="company image" />
        </div>
        <div className={cx('textArea', { typeHover: description })}>
          <em className={cx('imgTitle')}>{caption}</em>
          {description && (
            <div className={cx('hoverTextArea')}>
              <div className={cx('hoverTextWrap')}>
                <em className={cx('imgHoverTitle')}>{caption}</em>
                <p className={cx('imgDesc')}>{description}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  });

  return (
    <div className={cx('imgArea')}>
      <div className={cx('infoWrap')}>
        <p className={cx('desc')}>
          <span className={cx('emphasis')}>
            내가 일하게 될 곳의
            <br />
            공간, 동료, 브랜드 이미지
          </span>
          를
          <br />
          살펴보세요!
        </p>

        <div className={cx('pageInfoInner')}>
          <button type={'button'} className={cx('btn')} onClick={handlePrev}>
            <Icon name="arrowLeftLight" width={32} height={32} />
          </button>

          <span className={cx('pageTextArea')}>
            <p className={cx('pageNumText')}>
              <span className={cx('emphasis')}>{activeSlideIndex}</span>
              {images.length}
            </p>
          </span>

          <button type={'button'} className={cx('btn')} onClick={handleNext}>
            <Icon name="arrowRightLight" width={32} height={32} />
          </button>
        </div>
      </div>

      <Slider className={cx('imgListWrap')} {...settings} ref={sliderRef}>
        {imaListEls}
      </Slider>
    </div>
  );
};

export default CompanyImage;
